@file:Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")

package com.wintermar.inspection.feature.domain.usecase.reference

import com.wintermar.inspection.core.domain.FlowResult
import com.wintermar.inspection.feature.domain.model.template.TemplateOptionModel
import com.wintermar.inspection.feature.domain.repository.ReferenceRepository
import kotlinx.coroutines.flow.Flow

actual class GetListTemplateOptionUseCaseImpl actual constructor(val referenceRepository: ReferenceRepository) :
    GetListTemplateOptionUseCase {
    actual override operator fun invoke(): Flow<FlowResult<List<TemplateOptionModel>>> {
        return referenceRepository.getTemplateOptions()
    }
}
